import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, state, transition, trigger, style } from '@angular/animations';

@Component({
  selector: 'app-badge-with-button',
  templateUrl: './badge-with-button.component.html',
  styleUrls: ['./badge-with-button.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate(1600)
      ])
    ])]
})
export class BadgeWithButtonComponent<T>{
  @Input() badgeText: string = "";
  @Input() item: any;
  @Input() badgeClass: string | undefined;
  @Output() buttonAction = new EventEmitter<T>();
  @Output() badgeAction = new EventEmitter<T>();
  @Input() badgeColor: 'red' | 'green' | 'orange' | 'blue' | 'yellow' | 'grey' | undefined;

  constructor() {

  }

  badgeClicked(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.badgeAction.next(this.item);
  }

  buttonClicked(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.buttonAction.next(this.item);
  }

}
